import request from './request'

export function ipadControl(data) {
  return request({
    url: '/meeting/ipadControl',
    method: 'get',
    params: data
  })
}

// 获取用户信息
export function getUser(access_token) {
  const data = '=' + access_token
  return request({
    // url: '/test/api/User/GetUserInfo ',
    url: '/api/User/GetUserInfo ',
    method: 'post',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/index.js